/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Shopping_AddInputs */

const en_recipe_shopping_add = /** @type {(inputs: Recipe_Shopping_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to list`)
};

const de_recipe_shopping_add = /** @type {(inputs: Recipe_Shopping_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf die Liste`)
};

/**
* | output |
* | --- |
* | "Add to list" |
*
* @param {Recipe_Shopping_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_shopping_add = /** @type {((inputs?: Recipe_Shopping_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Shopping_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_shopping_add(inputs)
	return en_recipe_shopping_add(inputs)
});